// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   API_URL : 'https://localhost:44364/api',
//   IMG_PATH: 'https://localhost:44364/',
//   IMG_PATH_CATEGORY: 'https://localhost:44364/',
//   IMG_PATH_LOGO: 'https://localhost:44364/',
//   production: false,
// };

export const environment = {
  API_URL : 'https://lozz.conome.mk/api',
  IMG_PATH: 'https://lozz.conome.mk/',
  IMG_PATH_CATEGORY: 'https://lozz.conome.mk/',
  IMG_PATH_LOGO: 'https://lozz.conome.mk/',
  production: false,
};

/*
 * For easier  debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
